import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { TextInputRevealPassword, useScreenQuery } from 'playup-web-core';
import PasswordTooltip from '../../User/components/SignUpModal/PasswordTooltip';

const ControlledTextInputRevealPassword = ({
	kind = 'white',
	fieldName,
	label,
	placeholder,
	type,
	disabled,
	style,
	autoComplete,
	textAlign,
}: ControlledTextInputRevealPasswordProps) => {
	const {
		field,
		fieldState: { error },
	} = useController({
		name: fieldName,
	});
	const { watch } = useFormContext();
	const { isSmall } = useScreenQuery();

	const [showPasswordTooltip, setShowPasswordTooltip] = React.useState<boolean>(false); //TODO: move to hook form?
	const password = watch('password');

	return (
		<div style={{ position: 'relative' }}>
			{showPasswordTooltip && <PasswordTooltip password={password} isSmallScreen={isSmall} />}
			<TextInputRevealPassword
				errorTextAlign={textAlign}
				ref={field.ref}
				style={style}
				kind={kind}
				label={label}
				autoComplete={autoComplete}
				type={type}
				placeholder={placeholder}
				error={error?.message}
				onChange={field.onChange}
				disabled={disabled}
				onFocus={() => {
					field.onBlur();
					setShowPasswordTooltip(true);
				}}
				onBlur={() => {
					field.onBlur();
					setShowPasswordTooltip(false);
				}}
			/>
		</div>
	);
};

export default ControlledTextInputRevealPassword;

interface ControlledTextInputRevealPasswordProps {
	kind?: string;
	hasBottomMargin?: boolean;
	label?: React.ReactElement | string;
	fieldName: string;
	placeholder: string;
	style?: any;
	type: string;
	disabled?: boolean;
	defaultValue?: string;
	autoComplete?: string;
	max?: string;
	min?: string;
	textAlign?: 'left' | 'center';
}
